export const getOrCreatePersistentUserId = (): string => {
  const STORAGE_KEY = 'unleash_user_id';

  try {
    let userId = localStorage.getItem(STORAGE_KEY);

    if (!userId) {
      userId = crypto.randomUUID();
      localStorage.setItem(STORAGE_KEY, userId);
    }

    return userId;
  } catch {
    console.warn('localStorage unavailable, using session-only ID');
    return crypto.randomUUID();
  }
};
